<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">聊天监控</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号状态：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>隐藏用户：</label>
          <el-select v-model="isDel" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in isDelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>禁言：</label>
          <el-select v-model="bannedChatState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in bannedChatStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>异常用户：</label>
          <el-select v-model="abnormalState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in abnormalStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>设备冻结：</label>
          <el-select v-model="idfaBanState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in idfaBanStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item" v-if="isLinlu">
          <label>关注类型：</label>
          <el-select v-model="focusState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in focusStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="最新违规时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <ElButtons type="success" icon="ChatDotRound" @click="sendSysMsg">发送通知</ElButtons>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="110">
            <template #default="scope">
              <el-image
                  style="width: 80px; height: 80px"
                  :src="scope.row.headImg.smallHeadImg"
                  @click="showImg(scope.row)"
                  class="cursor"
              >
              <template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="基本信息" v-if="checkColList.indexOf('基本信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth"/>
            </template>
          </el-table-column>
          <el-table-column property="chatViolationTimeShow" label="最新违规时间" v-if="checkColList.indexOf('最新违规时间') > -1" />
          <el-table-column property="abnormalNum" label="违规内容条数" v-if="checkColList.indexOf('违规内容条数') > -1" class-name="cursor">
            <template #default="scope">
              <span style="color: #409eff"> {{ scope.row.violationNum }}</span>
            </template>
          </el-table-column>
<!--          <el-table-column label="封号状态" v-if="checkColList.indexOf('封号状态') > -1">-->
<!--            <template #default="scope">-->
<!--              <p v-if="!scope.row.isForbidden">未封号</p>-->
<!--              <p v-if="scope.row.isForbidden" style="color: red">已封号</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
<!--              <p v-if="!scope.row.isBannedChat">未禁言</p>-->
<!--              <p v-if="scope.row.isBannedChat" style="color: red">已禁言</p>-->
              <p>封号状态：<span :style="{color: scope.row.isForbidden?'red':''}">{{scope.row.isForbidden?'已封号':'未封号'}}</span></p>
              <p>禁言状态：<span :style="{color: scope.row.isBannedChat?'red':''}">{{scope.row.isBannedChat?'已禁言':'未禁言'}}</span></p>
              <p v-if="isLinlu" :style="{color:scope.row.focusState > 3?'red':'#aaaaaa' }">{{
                  scope.row.focusState == 0?'未关注':
                  scope.row.focusState == 1?"已关注":
                  scope.row.focusState == 2?"自动取消关注":
                  scope.row.focusState == 3?"手动取消关注":
                  scope.row.focusState == 4?"已关注-封号":
                  scope.row.focusState == 5?"已关注-手动":
                  scope.row.focusState == 6?"已关注-设备异常":
                  scope.row.focusState == 7?"已关注-IP异常":
                  scope.row.focusState == 8?"已关注-订单异常":
                  scope.row.focusState == 9?"已关注-省份不一致":""
                }}</p>
            </template>
          </el-table-column>
          <el-table-column property="warnNum" label="警告记录" v-if="checkColList.indexOf('警告记录') > -1" class-name="cursor">
            <template #default="scope">
              <span style="color: #409eff"> {{ scope.row.relWarnMsgNum }}</span>
            </template>
          </el-table-column>
          <el-table-column property="reportNum" label="被举报记录" v-if="checkColList.indexOf('被举报记录') > -1" class-name="cursor">
            <template #default="scope">
              <span style="color: #409eff"> {{ scope.row.relReportNum }}</span>
            </template>
          </el-table-column>
          <el-table-column property="bannedNum" label="禁言记录" v-if="checkColList.indexOf('禁言记录') > -1" class-name="cursor">
            <template #default="scope">
              <span style="color: #409eff"> {{ scope.row.relBannetChatNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
<!--              <el-space direction="vertical" alignment="left">-->
<!--                <el-button v-if="scope.row.showState == 0 || !scope.row.showState" type="primary" size="small" @click="updateHideState(scope.$index, scope.row, 1)" v-loading="scope.row['hideStateLoading']">隐藏</el-button>-->
<!--                <el-button v-if="scope.row.showState == 1" type="success" size="small" @click="updateHideState(scope.$index, scope.row, 0)" v-loading="scope.row['hideStateLoading']">取消隐藏</el-button>-->
<!--                <el-button v-if="scope.row.forbiddenState == 0" type="primary" size="small" @click="updateForbidState(scope.$index, scope.row, 1)" v-loading="scope.row['forbidStateLoading']">封号</el-button>-->
<!--                <el-button v-if="scope.row.forbiddenState == 1" type="success" size="small" @click="updateForbidState(scope.$index, scope.row, 0)" v-loading="scope.row['forbidStateLoading']">取消封号</el-button>-->
<!--                <el-button v-if="scope.row.isBannedChat" type="success" size="small" @click="updateBannedChat(scope.$index, scope.row, 0)" v-loading="scope.row['bannedLoading']">解除禁言</el-button>-->
<!--                <el-button v-if="!scope.row.isBannedChat" type="danger" size="small" @click="updateBannedChat(scope.$index, scope.row, 1)">禁言</el-button>-->
<!--              </el-space>-->
              <ActionButton :row="scope.row" showList="hide,forbidden,abnormal,idfa,chat,point"/>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import ActionButton from "@/components/resume/ActionButton";
import {
  getChatMonitorPageList,
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import WarnListDialog from "./components/monitor/WarnListDialog";
import ReportListDialog from "./components/monitor/ReportListDialog";
import BannedChatListDialog from "./components/monitor/BannedChatListDialog";
import AbnormalChatList from "./components/monitor/AbnormalChatList";
import UserLog from "@/components/UserLog/UserLog";
import {common} from "@/assets/shared/select-constant";
import SendSystemMessageChat from "@/components/SendSystemMessageChat";
import BannedChatDialog from "@/components/resume/BannedChatDialog";

export default {
  name: "ChatMonitor",
  components: { DatePickerRange, SearchComponents, UserLog, ActionButton},
  data() {
    return {

      isOnly: false,
      isLinlu: false,

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      isDelArray: common.showStateList,
      isDel: common.showStateList[0]['value'],

      forbiddenStateArray: common.forbiddenStateList,
      forbiddenState: common.forbiddenStateList[1]['value'],

      bannedChatStateArray: [
        {label: '不限', value: -1},
        {label: '已禁言', value: 1},
        {label: '未禁言', value: 0},
      ],
      bannedChatState: -1,

      //异常用户
      abnormalStateArray: [
        {label: '不限', value: -1},
        {label: '正常', value: 0},
        {label: '信息异常', value: 1}
      ],
      abnormalState: -1,

      // 冻结设备
      idfaBanStateArray: [
        {label: '不限', value: -1},
        {label: '未冻结', value: 0},
        {label: '已冻结', value: 1}
      ],
      idfaBanState: -1,

      //关注类型
      focusStateArray: [
        {label: '不限', value: -1},
        {label: '未关注', value: 0},
        {label: '已关注', value: 1},
        {label: '自动取消关注', value: 2},
        {label: '手动取消关注', value: 3},
        {label: '已关注-封号', value: 4},
        {label: '已关注-手动', value: 5},
        {label: '已关注-设备异常', value: 6},
        {label: '已关注-IP异常', value: 7},
        {label: '已关注-订单异常', value: 8},
        {label: '已关注-省份不一致', value: 9},
      ],
      focusState: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        // {label : '违规内容', value : 4}
      ],
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['最新违规时间', '头像', '基本信息', '违规内容条数', '状态', '警告记录', '被举报记录', '禁言记录', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,


      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.isDel = -1;
      this.forbiddenState = 0;
      this.bannedChatState = -1;
      this.abnormalState = -1;
      this.idfaBanState = -1;
      this.searchValue = '';
      this.focusState = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['isDel'] = this.isDel;
      param['forbiddenState'] = this.forbiddenState;
      param['bannedChatState'] = this.bannedChatState;
      param['abnormalState'] = this.abnormalState;
      param['idfaBanState'] = this.idfaBanState;
      param['focusState'] = this.focusState;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getChatMonitorPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '警告记录') {
        Dialog.open({
          title: row.nickName + '警告记录',
          component: WarnListDialog,
          data: {
            id: row.userId,
            width: '800px'
          }
        })
      }

      if(column.label == '被举报记录') {
        Dialog.open({
          title: row.nickName + '被举报记录',
          component: ReportListDialog,
          data: {
            id: row.userId,
            width: '800px'
          }
        })
      }

      if(column.label == '禁言记录') {
        Dialog.open({
          title: row.nickName + '禁言记录',
          component: BannedChatListDialog,
          data: {
            id: row.userId,
            width: '800px'
          }
        })
      }

      if(column.label == '违规内容条数') {
        Dialog.open({
          title: row.nickName + '违规内容条数',
          component: AbnormalChatList,
          data: {
            id: row.userId,
            width: '1000px'
          }
        })
      }

    },


    //单个更新隐藏状态
    updateHideState(idx, row, state) {
      this.$confirm('确定' + (state == 1?'【隐藏】':'【取消隐藏】') + '用户' +'【' + row.nickName + '】?').then(()=>{
        this.pageDataList[idx]['hideStateLoading'] = true
        let param = {}
        param['ids'] = row.userId
        param['showState'] = state
        postFormData(updateShowState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList[idx]['showState'] = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['hideStateLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['hideStateLoading'] = false
        })
      })
    },


    //单个更新封号状态
    updateForbidState(idx, row, state) {
      this.$confirm('确定' + (state == 1?'【封号】':'【取消封号】') + '用户' +'【' + row.nickName + '】?').then(()=>{
        this.pageDataList[idx]['forbidStateLoading'] = true
        let param = {}
        param['ids'] = row.userId
        param['forbiddenState'] = state
        postFormData(updateForbiddenState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList[idx]['forbiddenState'] = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['forbidStateLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['forbidStateLoading'] = false
        })
      })
    },


    //更新注销状态
    updateDelState(idx, row, state) {
      this.$confirm('确定' + (state==1?'【注销】用户':'【取消注销】用户') +'【' + row.nickName + '】?').then(()=>{
        this.pageDataList[idx]['delStateLoading'] = true
        let param = {}
        param['userId'] = row.userId
        param['isDel'] = state
        postFormData(updateDelState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList[idx]['isDel'] = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['delStateLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['delStateLoading'] = false
        })
      })
    },


    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList
      })
    },

    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessageChat,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    //单个禁言/解除
    updateBannedChat(idx, row, state) {
      let userIdArr = [];
      userIdArr.push(row.userId);
      if(state == 1) {
        Dialog.open({
          title: '禁言时间',
          component: BannedChatDialog,
          data: {
            userIdArray: userIdArr,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }else if (state == 0) {
        this.$confirm('确定对用户【'+ row.nickName + '】解除禁言？')
            .then(() => {
              this.pageDataList[idx]['bannedLoading'] = true
              let param = {}
              param['userIdArr'] = userIdArr
              param['state'] = 0
              param['day'] = 0
              postFormData(addBannedChat, param).then((data) => {
                let {code, msg} = data;
                if ( code == 200 ) {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'success'
                  })
                  this.pageDataList[idx]['isBannedChat'] = 0
                } else {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'warning'
                  })
                }
                this.pageDataList[idx]['bannedLoading'] = false
              }).catch(()=>{
                this.pageDataList[idx]['bannedLoading'] = false
              })
            })
            .catch(() => {
              // catch error
            })
      }
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    if(window.location.hostname == 'only.backstage.yiban1314.com') {
      this.isOnly = true
    }
    if(window.location.hostname == 'backstage.youban1314.cn' || window.location.port == '20030' ) {
      this.isLinlu = true
    }
    this.getPage();
  }
}
</script>

<style scoped>

</style>
